import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function CircularIndeterminate({size}) {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress 
        size={size ? size : 20} 
        sx={{ color: 'red' }} 
      />
    </Box>
  );
}
